// src/api/itemVariantsService.js ver 01 Jan 12 2026 3:43pm SB119
// src/api/itemVariantsService.js ver 00 Nov 19 2025 10:51 pm - SB112
import { callCloudFunction } from './apiClient';

export const getItemVariants = async (tenantid, token, page = 1, limit = 20, statusFilter = 'no-filter', associatedItemSeqIdFilter = 'no-filter') => {
  return callCloudFunction('itemVariantsCrud', 'GET', null, null, token, null,{
      pathParams: { tenantid, operation: 'list' },
      queryParams: { page, limit, statusfilter: statusFilter, associateditemseqidfilter: associatedItemSeqIdFilter }
  });
};

export const getItemVariantById = async (tenantid, id, token) => {
  return callCloudFunction('itemVariantsCrud', 'GET', null, id, token, null,{
      pathParams: { tenantid, operation: 'getById', id }
  });
};

export const addItemVariant = async (tenantid, itemVariantData, token) => {
  return callCloudFunction('itemVariantsCrud', 'POST', itemVariantData, null, token, null,{
      pathParams: { tenantid, operation: 'add' }
  });
};

export const updateItemVariant = async (tenantid, id, itemVariantData, token) => {
  return callCloudFunction('itemVariantsCrud', 'PUT', itemVariantData, null, token, null,{
      pathParams: { tenantid, operation: 'update', id }
  });
};

// NEW: Helper to fetch all active RawItems for dropdowns
export const getAllActiveRawItemsForDropdown = async (tenantid, token) => {
    // Calls rawItemsCrud 'list' operation with statusFilter='Active' to get all active raw items
    return callCloudFunction('rawItemsCrud', 'GET', null, null, token, null,{
        pathParams: { tenantid, operation: 'list' },
        queryParams: { limit: 1000, statusfilter: 'Active' } // Fetch a large enough limit for all active raw items
    });
};
// NEW: Helper to fetch all active ItemVariants for dropdowns (for ItemVariantPackage)
export const getAllActiveItemVariantsForDropdown = async (tenantid, token) => {
    // Calls itemVariantsCrud 'listActvItemVrtNmIds' operation directly
    // return callCloudFunction('listActiveItemVariantNamesAndIds', 'GET', null, null, token, null,{
    return callCloudFunction('itemVariantsCrud', 'GET', null, null, token, null,{
        pathParams: { tenantid, operation: 'listActvItemVrtNmIds' } // operation is part of pathParams
    });
};